"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { cn } from "@/lib/utils"
import { Link2 } from "lucide-react"

export function EnquirySidebar() {
    const pathname = usePathname()

    const links = [
        { name: "ONLINE ADMISSION", href: "/school-admission" },
        { name: "RTE", href: "/rte" },
        { name: "CAREER", href: "/career" },
        { name: "FEE STRUCTURE", href: "/fee-structure" },
    ]

    return (
        <div className="space-y-8">
            {/* Enquiry Menu */}
            <div className="bg-gray-100 rounded-lg overflow-hidden">
                <div className="bg-[#444] text-white py-3 px-4 text-center font-medium">
                    Enquiry
                </div>
                <div className="flex flex-col">
                    {links.map((link) => (
                        <Link
                            key={link.name}
                            href={link.href}
                            className={cn(
                                "px-4 py-3 text-sm font-medium border-b border-gray-200 last:border-0 hover:bg-gray-200 transition-colors uppercase",
                                pathname === link.href ? "bg-[#e8d082] text-[#113545]" : "text-gray-700"
                            )}
                        >
                            {link.name}
                        </Link>
                    ))}
                </div>
            </div>

            {/* Important Links */}
            <div className="rounded-lg overflow-hidden bg-[#002147] text-white pb-8">
                <div className="bg-[#fbbf24] text-[#002147] py-3 px-4 text-center font-bold relative mb-6 mx-4 mt-4 rounded-sm">
                    Important Links
                    <div className="absolute top-full left-0 w-full h-1 bg-[#fbbf24] mt-1 opacity-50"></div>
                </div>

                <div className="px-4 space-y-3">
                    <Link
                        href="#"
                        className="flex items-center gap-3 bg-white/10 p-3 rounded hover:bg-white/20 transition-colors"
                    >
                        <div className="bg-white rounded-full p-1">
                            <Link2 className="h-4 w-4 text-[#002147]" />
                        </div>
                        <span className="text-sm font-medium">demo</span>
                    </Link>
                    <Link
                        href="#"
                        className="flex items-center gap-3 bg-white/10 p-3 rounded hover:bg-white/20 transition-colors"
                    >
                        <div className="bg-white rounded-full p-1">
                            <Link2 className="h-4 w-4 text-[#002147]" />
                        </div>
                        <span className="text-sm font-medium">demo</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}
